import { State } from 'libs/react-virtualized-tree/state/TreeState';
import React, { Component, ErrorInfo } from 'react';
import RMErrorModal from './RMErrorModal'
import StackTrace from 'stacktrace-js';

interface State {
  hasError?: boolean;
  error?: string;
  info?: string;
  stack?: string;
  time?: Date;
  isLoadingStackTrace?: boolean;
}

export class RMErrorBoundary extends Component<State, any> {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: '',
      info: '',
      stack: '',
      time: new Date(),
      isLoadingStackTrace: false,
    };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({
      error,
      info: errorInfo,
      stack: error.stack,
      time: new Date(),
      isLoadingStackTrace: true,
    });

    StackTrace.fromError(error).then((stackErrorList) => {
      this.setState((prvState) => ({
        ...prvState,
        isLoadingStackTrace: false,
        stack: JSON.stringify(stackErrorList, null, 2),
      }));
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <RMErrorModal
          hasError={this.state.hasError}
          errorInfo={this.state.error.message}
          stackTrace={this.state.stack}
          errorTime={this.state.time}
          showClose={false}
          isLoadingStackTrace={this.state.isLoadingStackTrace}
        />
      );
    }
    return this.props.children;
  }
}
export default RMErrorBoundary;
